import { constructQuery } from "@root/src/lib/querystring";
export const createAuthenticationEventParams = (componentId, pageViewId) => {
    const params = {
        componentType: 'identityauthentication',
        componentId,
    };
    if (pageViewId) {
        params.viewId = pageViewId;
    }
    return `componentEventParams=${encodeURIComponent(constructQuery(params))}`;
};
